function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import throwError from "../throwError";
import unit from "../unit";
export var spaceFactor = 8;

/**
 * Returns values in rem units multiplied by 8. Should be used to define properties associated with spacing / layout (width, height, margin, padding etc.)
 *
 * @param values - Values provided in spaces (1 space = 8px)
 * @returns Values multiplied by 8 in rem units
 */

function space() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  var unitValues = values.map(function (value) {
    if (value === 0) {
      return 0;
    }
    if (value % 0.5 !== 0) {
      throwError("Passed values must be divisible by 0.5!");
    }
    return spaceFactor * value;
  });
  return unit.apply(void 0, _toConsumableArray(unitValues));
}
export default space;